<template>
  <v-container fluid fill-height pa-0 ma-0>
    <v-app-bar
      app
      elevation="0"
      dark
      color="secondary"
      clipped-right
      clipped-left
    >
      <img src="@/assets/logo.svg" alt="avatar" width="200" />
      <v-divider class="mx-4 hidden-xs-only" inset vertical></v-divider>
      <span class="subheading hidden-xs-only">{{
        $Amplify.I18n.get("Business Intelligence for Public Procurement")
      }}</span>
      <v-spacer></v-spacer>
      <user></user>
    </v-app-bar>

    <v-content>
      <v-container>
        <v-row align-content="center" justify="center">
          <v-col style="max-width:500px" class="align-self-center">
            <span class="display-2 font-weight-thin"
              >¡{{ $Amplify.I18n.get(`Welcome`) }}
            </span>
            <span class="display-2 font-weight-light">{{
              this.$store.getters.user.attributes.name
            }}</span>
            <span class="d-block subtitle-1 font-weight-light pt-10">
              <b>PacReport</b>
              {{
                $Amplify.I18n.get(
                  `is the business intelligence solution for public purchases with which you can explore the purchasing plans of the contracting entities, allowing you to analyze the supply and demand existing in the public sector in the simplest and most practical way you have ever imagined, helping you to identify business opportunities and to empathize with the competitive dynamics of public purchases.`
                )
              }}</span
            >
            <div class="d-block headline font-weight-regular pt-4">
              {{ $Amplify.I18n.get(`Please complete the registration`) }}
            </div>
          </v-col>
          <v-divider class="mx-5 hidden-sm-and-down" vertical></v-divider>
          <v-col style="max-width:433px" class="align-self-center">
            <ValidationObserver
              v-if="!selectedCountry"
              ref="obs"
              v-slot="{ invalid, validated }"
            >
              <v-card color="transparent" :elevation="0">
                <v-card-title>
                  <span class="title font-weight-regular">{{
                    $Amplify.I18n.get("Select country")
                  }}</span>
                </v-card-title>

                <v-card-text>
                  <form>
                    <ValidationProvider
                      :name="$Amplify.I18n.get('country')"
                      rules="required"
                    >
                      <v-radio-group
                        v-model="selectedCountry"
                        style="padding:0px; margin:0px"
                      >
                        <v-radio
                          v-for="item in countries"
                          :key="item.name"
                          name="selectedCountry"
                          :label="item.name"
                          :value="item.countryCode"
                        ></v-radio>
                      </v-radio-group>
                    </ValidationProvider>
                  </form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-on:click="next"
                    color="primary"
                    :disabled="invalid || !validated"
                  >
                    {{ $Amplify.I18n.get("Next") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </ValidationObserver>

            <registrar-empresa
              v-if="
                selectedCountry &&
                  selectedCountry === 'EC' &&
                  this.$store.getters.tipoCliente == 'proveedor'
              "
            ></registrar-empresa>
<!--             <registrar-empresa
              v-if="
                selectedCountry &&
                  selectedCountry === 'EC' &&
                  this.$store.getters.tipoCliente == 'proveedor'
              "
            ></registrar-empresa> -->
           <!--  <registrar-entidad
              v-if="
                selectedCountry &&
                  selectedCountry === 'EC' &&
                  this.$store.getters.tipoCliente == 'entidad'
              "
            ></registrar-entidad> -->

            <v-card
              v-if="selectedCountry && selectedCountry != 'EC'"
              max-width="600"
              color="transparent"
              :elevation="0"
            >
              <v-card-title>
                <span class="title font-weight-regular">{{
                  $Amplify.I18n.get(
                    "Servicio no disponible en el país seleccionado"
                  )
                }}</span>
              </v-card-title>

              <v-card-text>
                Estamos trabajando para ofrecer servicios de gestión,
                automatización e inteligencia empresarial para compras públicas
                en varios países miembros de la Red Interamericana de Compras
                Gubernamentales (RICG)
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-on:click="selectedCountry = null" color="primary">
                  {{ $Amplify.I18n.get("Back") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer app color="transparent">
      <v-row align-content="center" justify="center">
        <v-col class="text-center body-2 ma-0 pa-0">
          &reg; Inteldatos 2021 -
          {{ this.$Amplify.I18n.get("All rights reserved") }}
        </v-col>
      </v-row>
    </v-footer>
  </v-container>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import User from "@/components/User";
import countries from "@/assets/countriesRICG";
import RegistrarEmpresa from "@/components/ec/RegistrarEmpresa";
import RegistrarEntidad from "@/components/ec/RegistrarEntidad";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  components: {
    User,
    RegistrarEmpresa,
    RegistrarEntidad,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      countries,
      selectedCountry: null,
    };
  },
  methods: {
    next() {
      console.log("dsd");
    },
  },
  watch: {},
  beforeCreate: function() {
    AmplifyEventBus.$on("back-to-select-country", () => {
      this.selectedCountry = null;
    });
  },
  beforeDestroy: function() {
    AmplifyEventBus.$off("back-to-select-country");
  },
};
</script>
